import { Link } from 'wouter-preact'

import { Typography, DAppIcon, CloseX } from 'components'
import { removeDApp } from 'components/UI/organisms/sidebar/state'

interface Props {
	id: string
	isLoading: boolean
	name: string
}

const SmartContractCard = ({ id, name, isLoading }: Props) => {
	if (isLoading) {
		return (
			<div class='group flex h-28 w-full max-w-[250px] animate-pulse rounded-md bg-black-800 p-5' />
		)
	}

	return (
		<li class='group relative max-w-none lg:max-w-[250px]'>
			<Link
				class='flex w-full items-center gap-5 rounded-md bg-black-800 p-4 group-hover:pr-7'
				href={`/smart-contract/${name}/workspace`}
			>
				<DAppIcon className='text-black-200 group-hover:text-product' />
				<Typography
					class='truncate'
					color='text-black-200 group-hover:text-black-100 flex-1'
					text={name}
					variant='text2'
				/>
			</Link>
			<button
				aria-label={`Remove smart contract ${name}`}
				class='absolute right-3 top-4 z-10 hidden h-3 w-3 text-product transition-opacity duration-100 group-hover:flex'
				onClick={() => removeDApp(id)}
				type='button'
			>
				<CloseX />
			</button>
		</li>
	)
}

export { SmartContractCard }
